import { Box } from '@mui/joy'

const TaboolaFeedB = () => {
	return (
		<Box
			id="taboola-recommendation-b_desktop_2x3"
			className="print-hide"
			display={{ xs: 'none', md: 'block' }}
		/>
	)
}

export default TaboolaFeedB
